export function isString(obj) {
    return typeof obj === 'string';
}
